import React from 'react';

const AppConfig = React.createContext(undefined);

export { AppConfig };
